import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 0v17c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3V0zm17 18H3c-.6 0-1-.4-1-1V2.015h16V17c0 .6-.4 1-1 1M14 3c-.6 0-1 .4-1 1 0 1.7-1.3 3-3 3S7 5.7 7 4c0-.6-.4-1-1-1s-1 .4-1 1c0 2.8 2.2 5 5 5s5-2.2 5-5c0-.6-.4-1-1-1"
    }, null, -1)
  ]))]))
}
export default { render: render }